import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

export interface DashboardStore {
	data: any
	setData: (data: any) => void
	getData: (filter: any) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = '/suppliers/dashboard'

export const useDashboardStore = createWithEqualityFn<DashboardStore>(
	set => ({
		data: {},
		setData: (data: any) => set({ data }),
		getData: async filter => {
			return axios
				.get(`${API_SLUG}`, {
					params: cleanParamsFilter(filter),
				})
				.then(res => {
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		clearState: () => set({ data: {} }),
	}),
	Object.is
)
